document.addEventListener('DOMContentLoaded', () => {
    const url = new URL(window.location.href),
        container = document.querySelector(".press-list"),
        listBlocks = document.querySelectorAll(".press-list .press-list__block"),
        pageCount = Math.ceil(listBlocks.length),
        pagination = document.querySelector('.press-list__pagination'),
        paginationNumbers = document.querySelectorAll(".press-list__pagination .pagination-number"),
        nextButton = document.querySelector(".press-list__pagination #next-button"),
        prevButton = document.querySelector(".press-list__pagination #prev-button")
    let currentPage = 1

    function setCurrentPage(pageNum, changeState) {
        if (changeState) {
            url.searchParams.set('page', pageNum)
            window.history.pushState('', '', url.href);
        }

        currentPage = pageNum
        window.scrollTo({top: 0, behavior: 'smooth'});

        pagination ? handleActivePageNumber() : null
        pagination ? handlePageButtonsStatus() : null

        listBlocks.forEach((item, index) => {
            item.classList.remove('active')
            if (item.dataset.index == currentPage) {
                item.classList.add('active')
            }
        })
    }

    function handleActivePageNumber() {
        paginationNumbers.forEach((el) => {
            if (+el.dataset.number === currentPage) {
                el.classList.add('active')
            } else if (el.classList.contains('active')) {
                el.classList.remove('active')
            }
        })
    }

    function handlePageButtonsStatus() {
        if (currentPage === 1) {
            prevButton.classList.add('hidden')
        } else {
            prevButton.classList.remove('hidden')
        }

        if (pageCount === currentPage) {
            nextButton.classList.add('hidden')
        } else {
            nextButton.classList.remove('hidden')
        }
    }

    if (pageCount > 1) {
        if (!url.searchParams.get('page')) {
            setCurrentPage(1, true)
        } else {
            setCurrentPage(+url.searchParams.get('page'), false)
        }
    } else {
        container.classList.add('without-pagination')
    }

    if (pagination) {
        pagination.addEventListener('click', (e) => {
            if (e.target.closest('.press-list__pagination #prev-button')) {
                setCurrentPage(currentPage - 1, true);
            }

            if (e.target.closest('.press-list__pagination #next-button')) {
                setCurrentPage(currentPage + 1, true);
            }

            if (e.target.closest('.press-list__pagination .pagination-number')) {
                let paginationNumber = e.target.closest('.press-list__pagination .pagination-number')
                setCurrentPage(+paginationNumber.dataset.number, true)
            }
        })

        window.addEventListener("popstate", function() {
            setCurrentPage(+new URL(window.location.href).searchParams.get('page'), false)
        }, false)
    }
})